export const noop = function() {}